import {
    ICubeSourceHierarchyPolicy,
    ICubeSourcePolicyHierarchyProperties,
    IDimensionPolicyOptions
} from "../../PA.HyperRectangle.Core/CubeSource.IF";
import { DimensionType } from "../../PA.Core/PA.Core.IF.Hierarchy";
import * as _ from "lodash";
import { WB_CustomerRow, WB_PeriodRow, WB_PlanRow, WB_PlanTypeRow } from "../../PA.Core/PAdbSchemaRows";
import { PAdbContext } from "../../PA.Core/PAdbContext";
import { esWB_Customer, esWB_Period, esWB_Period_Type, esWB_Plan, esWB_Plan_Type } from "../../PA.Core/PAdbSchema";
import { PEAPlanCustomerHierarchy } from '../../PA.MD.Services/PEAPlanCustomerHierarchy'
import { PEAPlanProductHierarchy } from '../../PA.MD.Services/PEAPlanProductHierarchy'
import { PEAPlanPeriodHierarchy } from '../../PA.MD.Services/PEAPlanPeriodHierarchy'


export class PEAPlanHierarchyPolicy
    implements
        ICubeSourceHierarchyPolicy
{
    private dbContext: PAdbContext
    constructor() {
        this.dbContext = new PAdbContext()
    }
    get PolicyId(): string { return "PEAPlan" }

    async getHierarchyProperties(dimType: DimensionType, options: IDimensionPolicyOptions): Promise<ICubeSourcePolicyHierarchyProperties> {


        if(_.isEmpty(options) || _.isEmpty(options?.CubeSource))
            return undefined

        //-- Get the Plan  Row
        let wbPlanId = +options?.WB_PLAN_ID
        let planRow: WB_PlanRow = undefined
        if(!_.isEmpty(options.WB_PlanRow))
            planRow = options.WB_PlanRow
        else if (_.isNumber(wbPlanId))
            planRow = await this.dbContext.find(esWB_Plan, wbPlanId)

        if(_.isEmpty(planRow))
            return undefined

        wbPlanId = planRow.cif.WB_PLAN_ID

        switch(dimType){

            case DimensionType.Customer:
                let custHier = new PEAPlanCustomerHierarchy(wbPlanId, {dbContext: this.dbContext})
                return {
                    Hierarchy: custHier,
                    LeafLevel: 'Source',
                    EffectiveStartDt: planRow.InStore.Range.StartDt,
                    EffectiveEndDt: planRow.InStore.Range.EndDt,
                }

            case DimensionType.Product:
                let prdHier = new PEAPlanProductHierarchy(wbPlanId, {dbContext: this.dbContext})
                return {
                    Hierarchy: prdHier,
                    LeafLevel: 'ProductGroup',
                    EffectiveStartDt: planRow.InStore.Range.StartDt,
                    EffectiveEndDt: planRow.InStore.Range.EndDt,
                }

            case DimensionType.Time:
                let periodHier = new PEAPlanPeriodHierarchy(wbPlanId, {dbContext: this.dbContext})
                return {
                    Hierarchy: periodHier,
                    LeafLevel: 'Period',
                    EffectiveStartDt: planRow.InStore.Range.StartDt,
                    EffectiveEndDt: planRow.InStore.Range.EndDt,
                }

            default:
                return undefined

        }
    }

}